'use client';
import Script from 'next/script';
import { PropsWithChildren } from 'react';

import { HotjarScript } from '@/components/3rdParty/HotjarScript';
import { configPaymentsLib } from '@/modules/client/wrappers/ExternalMainScripts/helpers';

export const ExternalMainScripts = ({ children }: PropsWithChildren) => (
  <>
    {children}
    <HotjarScript />
    <Script
      src="https://payments-lib.cdn.s7s.ai/v1/index.js"
      onLoad={configPaymentsLib}
    />

    {/* <Script src="https://assets.livespins.com/sdk/js/livespins.js" /> */}
    <Script strategy="lazyOnload" src="/pixels/customer-io.js" />
  </>
);
